export default __webpack_public_path__ + "static/media/doIcon.c8dac977.svg";